module.exports = __webpack_public_path__ + "static/media/desserts-img-pattern.32056c5e.svg";